import { Directive, EventEmitter, HostListener, Output } from '@angular/core';
import { FiMobileAppHelperService } from '@fi-app/utilities/fi-services/mobile-app-helper.service';
import { FicQRAction } from '../../../app-cordova/app/fic-services/fic-scan-qr-code.service';
import { isObject } from '@fi-shared/utils/is-object';

let nextId = 0;

@Directive({
    selector: '[fiBtnMobileAppScanQRCode]',
    standalone: false,
})
export class FiBtnMobileAppScanQRCodeDirective {
    @Output() fiBtnMobileAppScanQRCode = new EventEmitter<FicQRAction>();
    callbackName: string;

    constructor(private mobileAppHelper: FiMobileAppHelperService) {
        this.callbackName = `FiBtnMobileAppScanQRCodeFor:${++nextId}`;
    }

    @HostListener('click')
    onClick() {
        this.mobileAppHelper.scanQRCode(this.callbackName);
    }

    @HostListener('window:message', ['$event'])
    onMessage(e: MessageEvent) {
        if (isObject(e.data) && e.data.name == this.callbackName)
            this.fiBtnMobileAppScanQRCode.emit(e.data.scannedData);
    }
}
